import merge from 'lodash.merge';
import { ActionConstants as CurrentUserActions } from '../actions';

const currentUserDefaults = {
  id: undefined,
  settings: {},
};

const setId = (state, action) => {
  return {
    ...state,
    id: action.payload,
    // clear token, but only when id is different
    token: state.id === action.payload ? state.token : null,
  };
};

const setType = (state, action) => {
  return {
    ...state,
    type: action.payload,
  };
};

const updateSettings = (state, action) => {
  // Deep merge needed for settings
  return merge({}, state, { settings: action.payload });
};

const updateAuth = (state, action) => {
  return {
    ...state,
    token: action.payload,
  };
};

const clearAuth = state => {
  return {
    ...state,
    id: null,
    token: null,
  };
};

const login = (state, action) => {
  return {
    ...state,
    ...action.payload,
  };
};

const logout = state => {
  return {};
};

const reducerLookup = {
  [CurrentUserActions.SET_ID]: setId,
  [CurrentUserActions.SET_TYPE]: setType,
  [CurrentUserActions.UPDATE_SETTINGS]: updateSettings,
  [CurrentUserActions.CLEAR_AUTH]: clearAuth,
  [CurrentUserActions.UPDATE_AUTH]: updateAuth,
  [CurrentUserActions.LOGIN]: login,
  [CurrentUserActions.LOGOUT]: logout,
};

export default (state = currentUserDefaults, action = {}) => {
  const reducer = reducerLookup[action.type];
  if (reducer) {
    if (typeof reducer === 'function') {
      return reducer(state, action);
    }
    // eventual fall through if we want to allow look up to pass static new state
    return state;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/redux-modules/current-user/reducers/index.js